import {
  presignAfImageUpload as presignAfImageUploadApi,
  confirmAfImageUpload as confirmAfImageUploadApi,
  getAfImageUrls as getAfImageUrlsApi,
} from "@/lib/api/clients/AfImageClient";
import { AfImageValue } from "@/types/AfImage";
import { handleErrorServer, ServerError } from "@/lib/api/errors/ErrorHandler";
import { isValidObjectId } from "@/lib/utils/input-validator";

// ── Guest IMAGE additional-field upload (mirrors AttachmentHandling) ──

export async function presignAfImageUpload(
  eventId: string,
  guestId: string,
  fieldName: string,
  data: { fileName: string; contentType: string; contentLength: number },
): Promise<{ uploadUrl: string; s3Key: string } | ServerError> {
  try {
    if (!isValidObjectId(eventId) || !isValidObjectId(guestId)) {
      throw new Error("Invalid ID.");
    }
    if (!fieldName) throw new Error("Invalid field name.");
    return await presignAfImageUploadApi(eventId, guestId, fieldName, data);
  } catch (error) {
    return handleErrorServer(error);
  }
}

export async function confirmAfImageUpload(
  eventId: string,
  guestId: string,
  fieldName: string,
  data: { s3Key: string },
): Promise<AfImageValue | ServerError> {
  try {
    if (!isValidObjectId(eventId) || !isValidObjectId(guestId)) {
      throw new Error("Invalid ID.");
    }
    if (!fieldName) throw new Error("Invalid field name.");
    return await confirmAfImageUploadApi(eventId, guestId, fieldName, data);
  } catch (error) {
    return handleErrorServer(error);
  }
}

export async function fetchAfImageUrls(
  eventId: string,
  requests: { guestId: string; fieldName: string }[],
): Promise<{ urls: Record<string, string> } | ServerError> {
  try {
    if (!isValidObjectId(eventId)) throw new Error("Invalid event ID.");
    if (requests.length === 0) return { urls: {} };
    return await getAfImageUrlsApi(eventId, requests);
  } catch (error) {
    return handleErrorServer(error);
  }
}
